<template>
  <div class="exam_page">
    <div class="exam_main" ref="middle_page">
      <div class="examPage">
        <div class="div-btn-icon">
          <button class="btn-tast btn-next-1" @click="goto_lesson">
            <img src="../../../static/images/icon-back-1.png" alt="" />
            <span> {{ $t("common.returnButton") }}</span>
          </button>
        </div>
        <div class="exam_begins_box">
          <p class="examination_notes" style="font-weight: 500">
            <span>{{ $t("home.performanceAnalysis") }}</span>
          </p>
          <div class="el-divider el-divider--horizontal div-mb"></div>

          <el-row class="flex-center">
            <el-col :span="8">
              <span class="user-name">
                {{ userName }}
              </span>
            </el-col>
            <el-col :span="8" class="size-24">
              {{titleCourseName}}
            </el-col>
          </el-row>
          <template v-for="(item, index) in listCourseScoreStatics">
            <div :key="index">
              <div class="el-divider el-divider--horizontal">
                <p
                  v-if="item.courseCompanyId == '0'"
                  style="color: red; font-size: 14px"
                >
                  <br />
                  {{ $t("scoreStatistics.message3") }}
                </p>
              </div>
              <el-row
                class="company-mb header_course_score"
                v-if="item.courseCompanyId != '0'"
              >
                <el-col class="header_course_score_test_mb name_test" :span="6">
                  <span class="name_test_title">{{ $t("scoreStatistics.testName") }}: </span>
                  <span class="name_test_content">
                    <template v-if="item.examId==null">
                      {{ $t("scoreStatistics.finalExam") }}
                    </template>
                    <template v-else>
                      {{ item.examName }}
                    </template>
                  </span>
                </el-col>
                <el-col class="header_course_score_test_mb score_test" :span="6">
                  {{ $t("scoreStatistics.message1") }} 
                  {{ item.infoCourseMaxScore }}
                  {{ $t("scoreStatistics.message2") }}
                </el-col>
                <el-col class="header_course_score_test_mb point_test" :span="6">
                  <span id="isPass">
                    <span class="lkt-em">{{ $t("scoreStatistics.result") }}: </span>
                    <template v-if="item.userScore >= Math.abs(item.examTotalScore*item.passPercent/100)">
                      {{ $t("scoreStatistics.point90") }}
                    </template>
                    <template v-else>
                      {{ $t("scoreStatistics.point80") }}
                    </template>
                  </span>
                </el-col>
                <el-col class="header_course_score_test_mb history_test" :span="6">
                  <a
                    class="a-history history_test_text"
                    @click="jumptoexamhistory(courseId, item)"
                    target="_blank"
                    >{{ $t("courseProgress.examhistory") }}</a
                  >
                </el-col>
              </el-row>
              <el-row
                class="company-mb"
                v-if="item.courseCompanyId != '0'"
              >
                <el-col :span="8" :offset="3">
                  <div style="display: inline-flex">
                    <div style="padding-left: 20px; text-align: left">
                      {{ $t("new.title24") }}：
                    </div>
                    <div style="text-align: left; margin-top: 2px;">{{ item.examTotalScore }}</div>
                  </div>
                  <div style="display: inline-flex">
                    <div style="padding-left: 20px; text-align: left">
                      {{ $t("scoreStatistics.passPercent") }}：
                    </div>
                    <div style="text-align: left; margin-top: 2px;">
                      <span>
                        {{ Math.abs(item.examTotalScore*item.passPercent/100) }}
                      </span>
                    </div>
                  </div>
                  <ve-histogram
                    :data="item.chartData4"
                    :settings="item.chartSettings"
                    :series="item.series"
                    :extend="item.chart4Extend"
                  ></ve-histogram>
                </el-col>
                <el-col :span="14">
                  <ve-pie :data="item.chartDataD"></ve-pie>
                </el-col>
              </el-row>
            </div>
          </template>
        </div>
        <div class="mind_map" v-if="initMindMap">
          <js-mind
            :values="mind"
            :options="options"
            ref="jsMind"
            height="800px"
          ></js-mind>
        </div>
      </div>
    </div>
    <loading :showLoading="showLoadingFlg" />
  </div>
</template>

<script>
import Vue from "vue";
import jm from "vue-jsmind";
import { lang } from "../../assets/languages/getLanguageType.js";
import loading from "@/components/loading/loading";
Vue.use(jm);
Vue.prototype.$lang = lang;

export default {
  name: "course_score_statistics",
  components: {
    loading
  },
  data() {
    return {
      showLoadingFlg: false,
      listCourseScoreStatics: [],
      maxScore: 0,
      fullMarks: 0,
      passMarks: 0,
      initMindMap: false,
      series: [],
      chartSettings: {},
      lang: null,
      xValueList: [],
      searchResultList: [],
      titleCourseName: this.$route.query.courseName,
      courseId: "",
      courseName: "",
      examIdStudents: null,
      courseCompanyId: "",
      num: 0,
      userName: window.sessionStorage.getItem("name"),
      beginDate: "",
      validity: "",
      isPass: "",
      chartDataD: {
        columns: ["点数区間", "人数"],
        rows: [
          { 点数区間: "Đậu", 人数: 2 },
          { 点数区間: "Không đậu", 人数: 6 },
        ],
      },
      chartData4: {
        columns: ['分数', '成绩'],
        rows: [
          { 点数: "", 成績: "" },
          { 点数: "", 成績: "" },
          { 点数: "", 成績: "" },
          { 点数: "", 成績: "" },
        ],
      },
      mind: {
        meta: {
          name: "example",
          author: "hizzgdev@163.com",
          version: "0.2",
        },
        format: "node_array",
        data: [
          { id: "rootTag", isroot: true, topic: this.$route.query.courseName },
        ],
      },
      options: {
        container: "jsmind_container",
        editable: false,
        theme: "warning",
      },
      secondChapterList: [],
      chart4Extend: {},
    };
  },
  mounted() {
    this.lang = this.$lang();
    const h = document.body.clientHeight - 50;
    this.$autoLogin().then(
      (data) => {
        const that = this;
        this.chartDataD.rows[0].点数区間 = window.vm.$i18n.t("scoreStatistics.point90");
        this.chartDataD.rows[1].点数区間 = window.vm.$i18n.t("scoreStatistics.point80");
        this.chartData4.rows[0].点数 = window.vm.$i18n.t("scoreStatistics.myScore");
        this.chartData4.rows[1].点数 = window.vm.$i18n.t("scoreStatistics.aveScore");
        this.chartData4.rows[2].点数 = window.vm.$i18n.t("scoreStatistics.maxPoint");
        this.chartData4.rows[3].点数 = window.vm.$i18n.t("scoreStatistics.minPoint");
        that.num = that.$route.query.num;
        that.courseId = that.$route.query.courseId;
        that.courseName = that.$route.query.courseName;
        that.examIdStudents = that.$route.query.examId;
        that.userId = window.sessionStorage.getItem("id");
        that.role = window.sessionStorage.getItem("role");
        that.$api
          .post("/courseStudy/getCourseSubOutlineListByTopOutline", {
            courseId: that.$route.query.courseId,
            courseName: that.$route.query.courseName,
          })
          .then((response) => {
            that.secondChapterList = response.data;
            for (let i = 0; i < response.data.length; i++) {
              if (1 == response.data[i].level) {
                that.mind.data.push({
                  id: response.data[i].id,
                  parentid: "rootTag",
                  topic: response.data[i].chapterName,
                });
                if (
                  1 == response.data[i].isEnd &&
                  response.data[i].scoringRate != null
                ) {
                  if (
                    parseFloat(response.data[i].scoringRate) >=
                    parseFloat("60%")
                  ) {
                    that.mind.data.push({
                      id: "scoringRate" + i,
                      parentid: response.data[i].id,
                      topic: response.data[i].scoringRate,
                      "background-color": "#99cc32",
                      "foreground-color": "#fefefe",
                    });
                  } else {
                    that.mind.data.push({
                      id: "scoringRate" + i,
                      parentid: response.data[i].id,
                      topic: response.data[i].scoringRate,
                      "background-color": "#ee0000",
                      "foreground-color": "#fefefe",
                    });
                  }
                }
              }
              if (
                2 == response.data[i].level ||
                3 == response.data[i].level ||
                4 == response.data[i].level ||
                5 == response.data[i].level
              ) {
                that.mind.data.push({
                  id: response.data[i].id,
                  parentid: response.data[i].parentId,
                  topic: response.data[i].chapterName,
                });
                if (
                  1 == response.data[i].isEnd &&
                  response.data[i].scoringRate != null
                ) {
                  if (
                    parseFloat(response.data[i].scoringRate) >=
                    parseFloat("60%")
                  ) {
                    that.mind.data.push({
                      id: "scoringRate" + i,
                      parentid: response.data[i].id,
                      topic: response.data[i].scoringRate,
                      "background-color": "#99cc32",
                      "foreground-color": "#fefefe",
                    });
                  } else {
                    that.mind.data.push({
                      id: "scoringRate" + i,
                      parentid: response.data[i].id,
                      topic: response.data[i].scoringRate,
                      "background-color": "#ee0000",
                      "foreground-color": "#fefefe",
                    });
                  }
                }
              }
            }
            that.initMindMap = true;
          });
          this.getDataContent();
      },
      () => {
        this.$router.push({
          path: "/home",
        });
      }
    );
  },
  methods: {
    getData(){
      return new Promise((resolve, reject) => {
          this.$api
            .post("/home/getsingleCourseScoreStatistics", {
              courseId: this.$route.query.courseId,
              languageType: this.$lang(),
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err.response);
            });
      });
    },
    getDataContent: async function(){
      this.showLoadingFlg = true;
      const self = this;
      let listCourseScore = await this.getData();
      // var listScoreStatic = [];
      // listCourseScore.forEach(value => {
      //   if (value.examId!=null&&value.examName==null) {
      //     return;
      //   } else {
      //     listScoreStatic.push(value);
      //   }
      // });
      // listCourseScore = listScoreStatic;
      return new Promise((resolve, reject) => {
        Promise.all(listCourseScore.map(item => {
            return self.getdataInfoCouse(item);
        })).then(function(results) {
          listCourseScore.forEach(value => {
            results.forEach(el => {
              if(value.examId==el.examId){
                value['infoCoursePassMarks'] = el.passMarks;
                value['infoCourseFullMarks'] = el.fullMarks;
                value['infoCourseIsTemp'] = el.isTemp;
                value['infoCourseMaxScore'] = el.maxScore;
                value['infoCourseRecentScore'] = el.recentScore;
                value['infoCourseRestCount'] = el.restCount;
              }
            });
            let xValueList = [];
            xValueList[0] = value.infoCourseRecentScore;
            xValueList[1] = value.avgScore;
            xValueList[2] = value.maxScore;
            xValueList[3] = value.minScore;
            value['chartDataD'] =  {
              columns: ["点数区間", "人数"],
              rows: [
                { 点数区間: window.vm.$i18n.t("scoreStatistics.point90"), 人数: value.passNum },
                { 点数区間: window.vm.$i18n.t("scoreStatistics.point80"), 人数: value.noPassNum },
              ],
            },
            value['chartData4'] = self.chartData4;
            if (self.$lang() == "1") {
              (value['chartSettings'] = {
                metrics: ["成績"],
                dimension: ["点数"],
              }),
                (value['series'] = [
                  {
                    name: "点数",
                    type: "bar",
                    barWidth: "50%",
                    data: xValueList,
                    itemStyle: {
                      normal: {
                        color: function (params) {
                          var colorList = [
                            "#65d186",
                            "#f67287",
                            "#f29e3c",
                            "#c05bdd",
                          ];
                          return colorList[params.dataIndex];
                        },
                      },
                    },
                  },
                ]);
            }
            if (self.$lang() == "3") {
              (value['chartSettings'] = {
                metrics: ["成績"],
                dimension: ["点数"],
              }),
                (value['series'] = [
                  {
                    name: "点数",
                    type: "bar",
                    barWidth: "50%",
                    data: xValueList,
                    itemStyle: {
                      normal: {
                        color: function (params) {
                          var colorList = [
                            "#65d186",
                            "#f67287",
                            "#f29e3c",
                            "#c05bdd",
                          ];
                          return colorList[params.dataIndex];
                        },
                      },
                    },
                  },
                ]);
            }
            if (self.$lang() == "2") {
              (value['chartSettings'] = {
                metrics: ["成績"],
                dimension: ["点数"],
              }),
                (value['series'] = [
                  {
                    name: "point",
                    type: "bar",
                    barWidth: "50%",
                    data: xValueList,
                    itemStyle: {
                      //通常情况下：
                      normal: {
                        color: function (params) {
                          var colorList = [
                            "#65d186",
                            "#f67287",
                            "#f29e3c",
                            "#c05bdd",
                          ];
                          return colorList[params.dataIndex];
                        },
                      },
                    },
                  },
                ]);
            }
            if (self.$lang() == "4") {
              (value['chartSettings'] = {
                metrics: ["成績"],
                dimension: ["点数"],
              }),
                (value['series'] = [
                  {
                    name: "Điểm thi",
                    type: "bar",
                    barWidth: "50%",
                    data: xValueList,
                    itemStyle: {
                      normal: {
                        color: function (params) {
                          var colorList = [
                            "#65d186",
                            "#f67287",
                            "#f29e3c",
                            "#c05bdd",
                          ];
                          return colorList[params.dataIndex];
                        },
                      },
                    },
                  },
                ]),
                (value['chart4Extend'] = {
                  series: {
                    barWidth: 50,
                  },
                  xAxisType: "value",
                  xAxis: {
                    axisLabel: {
                      interval: 0,
                      formatter: function (value) {
                        let result = "";
                        let maxLength = 10;
                        let valLength = value.length;
                        let rowNumber = Math.ceil(valLength / maxLength);
                        if (rowNumber > 1) {
                          for (let i = 0; i < rowNumber; i++) {
                            let temp = "";
                            let start = i * maxLength;
                            let end = start + maxLength;
                            temp = value.substring(start, end) + "\n";
                            result += temp;
                          }
                          return "{labelText|" + result + "}";
                        } else {
                          return "{labelText|" + value + "}";
                        }
                      },
                      rich: {
                        labelText: {
                          lineHeight: 18,
                        },
                      },
                    },
                  },
                });
            }
        });
        let listcheckIsNull = [];
        listCourseScore.forEach(el => {
          if(el.examId!=null){
            listcheckIsNull.push(el);
          }
        });
        listCourseScore.forEach(el => {
          if(el.examId==null){
            listcheckIsNull.push(el);
          }
        });
        // self.titleCourseName = listcheckIsNull[0].courseName;
        if (self.num==1) {
          let dataOfStudents = [];
          if (self.examIdStudents) {
            listCourseScore.forEach(el => {
              if(el.examId==self.examIdStudents){
                dataOfStudents.push(el);
              }
            });
            self.listCourseScoreStatics = dataOfStudents;
          } else {
            listCourseScore.forEach(el => {
              if(el.examId==null){
                dataOfStudents.push(el);
              }
            });
            self.listCourseScoreStatics = dataOfStudents;
          }
        } else {
          self.listCourseScoreStatics = listcheckIsNull;
        }
        
        self.showLoadingFlg = false;
        });
      });
    },
    getdataInfoCouse: async function(data){
      return new Promise((resolve, reject) => {
        this.$api
        .post("/studyCourseQuestion/getPastExamInfo", {
            courseId: this.$route.query.courseId,
            examId: data.examId,
        })
        .then((response) => {
          response.data['examId'] = data.examId;
          resolve(response.data);
        });
      });
    },
    jumptoexamhistory: function (courseId, data) {
      if (this.$route.query.isCurriculumExam) {
        this.$router.push({
          path: "examRecord",
          query: {
            examId: data.examId,
            courseId: courseId,
            courseName: this.courseName,
            examRecordReturnNum: 2,
            num: this.num,
            isCurriculumExam: true
          },
        });
      } else {
        this.$router.push({
          path: "examRecord",
          query: {
            examId: data.examId,
            courseId: courseId,
            courseName: this.courseName,
            examRecordReturnNum: 2,
            num: this.num,
          },
        });
      }
    },
    goto_lesson: function () {
      if (this.num == 1) {
        this.$router.push({
          path: "/home/courseScoreStatistics",
          query: {},
        });
      } else {
        let outlineInfo = {
          courseId: this.$route.query.courseId,
          courseName: this.$route.query.courseName,
        };
        if (this.$route.query.isCurriculumExam) {
          this.$router.push({
            path: "/home/curriculumExam",
            query: {
              outlineInfo: JSON.stringify(outlineInfo),
            },
          });
        } else {
          this.$router.push({
            path: "/home/curriculum",
            query: {
              outlineInfo: JSON.stringify(outlineInfo),
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped="scoped">
.page-bk-col {
  background-color: #ffffff;
}
.form-item {
  margin-left: 50px;
}
.font_col {
  color: #ffffff;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.exam_page {
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}

.exam_main {
  width: 100%;
  height: 100%;
  /*min-height: 100%;*/
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.examPage {
  /*min-width: 1800px;*/
  width: 96%;
  margin: 0 auto;
  padding-top: 20px;
  max-width: 1200px;
}

.examCenter_img {
  margin-top: 40px;
  width: 40%;
  margin-left: calc(20% - 30px);
  position: relative;
}

.examCenter_img img {
  height: 120px;
}

.examCenter_img p:first-child {
  font-size: 40px;
  color: #fafafa;
  font-family: marzo-w00-regular, fantasy;
  font-weight: 400;
}

.examCenter_img p:first-child span {
  font-size: 40px;
  color: #ff5252;
  font-family: braggadocio-w01, fantasy;
  font-weight: 400;
}

.examCenter_img p:nth-child(2) {
  font-size: 45px;
  color: #e8e6e6;
  font-family: roboto-thin, roboto, sans-serif;
  font-weight: 400;
}

.exam_begins_box {
  /*min-width: 700px;*/
  width: 90%;
  padding: 30px;
  border-radius: 15px;
  margin: 80px auto;
  background-color: #ecf5ff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}
.mind_map {
  /*min-width: 700px;*/
  width: 90%;
  padding: 30px;
  border-radius: 15px;
  margin: 80px auto;
  background-color: #ecf5ff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}
.course_box {
  /*min-width: 1250px;*/
  width: 100%;
  /*   padding: 30px;*/
  border-radius: 15px;
  /* : 10px auto; */
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.exam_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: black;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  display: -webkit-flex;
  margin-top: 20px;
  padding-top: 20px;
  /*border-top: 1px #414141 solid;*/
}

.exam_begins_box .el-col-offset-3 {
  margin-left: 1%;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes:first-child {
  margin-top: 40px;
}

.exam_btn {
  margin: -28px 0;
  margin-top: 3px;
  display: block;
  /*text-align: left;*/
  /*font-size: 16px;*/
  color: #fff;
  background-color: unset;
  padding: 6px 17px 6px 17px;
  /*border: 1px solid #323232;*/
  border-radius: 20px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  /*font-family: source-han-sans-simplified-c, sans-serif;*/
  /*font-weight: 200;*/
  /*font-style: normal;*/
  /*transition:0.5s ease;*/
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.1s ease;
}
.item {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0 10px;
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.a-history {
  background:#fff;
  color: #02adff;
}
/* .a-history:hover {
  background:#3792d6;
} */
.header_course_score {
  padding-bottom: 10px;
}
.name_test {
  padding-left: 30px;
  white-space: nowrap;
  text-overflow: ellipsis!important;
  overflow: hidden;
}
.score_test {
  text-align: right;
}
.point_test {
  text-align: right;
}
.history_test {
  text-align: right;
  padding-right: 12px;
}
@media (max-width: 1112px){
  .user-name {
      padding-top: 5px;
      color: #000!important;
  }
}
@media (max-width: 480px){
  .header_course_score_test_mb {
    padding-bottom: 10px;
  }
  .name_test {
    width: 100%!important;
    text-align: center;
    padding-left: 0px!important;
  }
  .name_test_title {
    display: none;
  }
  .name_test_content {
    font-size: 15px;
    font-weight: bold;
  }
  .score_test {
    width: 100%!important;
    text-align: center;
  }
  .point_test {
    width: 100%!important;
    text-align: center;
  }
  .history_test {
    padding-top: 4px;
    width: 100%!important;
    text-align: center;
  }
  .history_test_text {
    background-color: #0071c5;
    color: #fff;
    padding: 9px;
    border-radius: 10px;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/courseScoreStatistics/courseScoreStatistics.vue